export default function shareSocial () {
    const shareLinks = document.querySelectorAll(".post-single__share-link");
    const shareWraps = document.querySelectorAll(".post-single__share-wrap");
    const copyLinks = document.querySelectorAll(".post-single__share-copy");

    shareLinks.forEach(function (shareLink, index) {
        shareLink.addEventListener("click", function (event) {
            event.preventDefault();
            shareWraps[index].classList.toggle("share-active");
        });
    });

    copyLinks.forEach(function (copyLink, index) {
        copyLink.addEventListener("click", function (event) {
            event.preventDefault();
            const url = shareLinks[index].getAttribute("href");
            copyToClipboard(url);
        });
    });

    document.addEventListener("click", function (event) {
        const target = event.target;
        shareWraps.forEach(function (shareWrap) {
            if (!target.closest(".post-single__share-wrap")) {
                shareWrap.classList.remove("share-active");
            }
        });
    });
}

function copyToClipboard (text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    console.log("URL copied to clipboard:", text);
}
